import { defineStore } from "pinia";

export const RestaurantCar = defineStore("RestaurantCar", {
    state:()=>{
        return {
            dataList:[]
        }
    }
})